import type { MediaType } from '@disy/lib/media-type';

import type { ActionOptions } from 'cadenza/action';
import { AbstractExportActionWithCanExportChecked } from 'cadenza/actions/table/abstract-export-action-with-can-export-checked';
import { parseWorkbookUrl } from 'cadenza/api-client/workbook-api';
import { checkIfDataViewsDataCanBeExported, exportDataViewData } from 'cadenza/api-client/workbook-export-data-api';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';

export class AbstractDataViewExportAction extends AbstractExportActionWithCanExportChecked {
  #dataViewId;
  #actionContext;

  constructor(
    dataViewId: DataViewId,
    actionContext: ExportActionContext,
    mediaType: MediaType,
    options: ActionOptions & { dialogTitle?: string },
  ) {
    super(mediaType, options);
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
  }

  override canExport() {
    const { workbookNameAndHash } = parseWorkbookUrl(location.href)!; // will be reassigned on reload
    return checkIfDataViewsDataCanBeExported(
      workbookNameAndHash!,
      [this.#dataViewId],
      this.mediaType,
      this.#actionContext,
    );
  }

  override startExport() {
    const { workbookNameAndHash } = parseWorkbookUrl(location.href)!; // will be reassigned on reload
    return exportDataViewData({
      workbookNameAndHash: workbookNameAndHash!,
      dataViewId: this.#dataViewId,
      mediaType: this.mediaType,
      actionContext: this.#actionContext,
    });
  }
}
